import { Point } from "framer-motion";
import { action, makeObservable, observable } from "mobx";
import { ConsumerKind3, DragInfo3, DraggedElementInfo3 } from "./types";

export const draggedWeight = (a: ConsumerKind3) =>
  ({ rack: 0, miner: 1, section: 1, building: 2 } as { [x in ConsumerKind3]: number })[a];

export interface DragStore {
  draggedElements: DraggedElementInfo3[];
  drags: DragInfo3[];
  isDrag: boolean;
  mousePos?: Point;
  shift?: Point;
  toggleToDrag: (id: string, kind: ConsumerKind3, elementDragID: string, data: unknown) => void;
  setDrag: (isDrag: boolean) => void;
  clearDrag: (keep?: boolean) => void;
  initDragMouse: (mousePos?: Point, shift?: Point) => void;
  moveDragMouse: (shift: Point, mousePos?: Point) => void;
  clearDraggedElements: () => void;
}

export const createDragStore = (): DragStore => {
  const self: DragStore = {
    draggedElements: [],
    drags: [],
    isDrag: false,
    mousePos: undefined,
    shift: undefined,

    toggleToDrag(id: string, kind: ConsumerKind3, elementDragID: string, data: unknown) {
      const found = self.draggedElements.findIndex((el) => el.kind === kind && el.id === id);
      if (found < 0) {
        self.draggedElements = [
          ...self.draggedElements,
          { id, kind, dragID: elementDragID, data },
        ];
        self.drags = [...self.drags, { id, kind }];
      } else {
        self.draggedElements = self.draggedElements.filter((_, idx) => idx !== found);
        self.drags = self.drags.filter((el) => !(el.kind === kind && el.id === id));
      }
      self.draggedElements = [...self.draggedElements].sort(
        (x, y) => draggedWeight(y.kind) - draggedWeight(x.kind)
      );
      self.drags = [...self.drags].sort((x, y) => draggedWeight(y.kind) - draggedWeight(x.kind));
    },

    setDrag(isDrag: boolean) {
      self.isDrag = isDrag;
    },

    clearDrag(keep?: boolean) {
      self.isDrag = false;
      self.drags = keep ? self.drags : [];
      self.mousePos = keep ? self.mousePos : undefined;
      self.shift = keep ? self.shift : undefined;
    },

    initDragMouse(mousePos?: Point, shift?: Point) {
      self.mousePos = mousePos;
      self.shift = shift;
    },

    moveDragMouse(shift: Point, mousePos?: Point) {
      self.shift = shift;
      self.mousePos = mousePos;
    },

    clearDraggedElements() {
      self.draggedElements = [];
    },
  };

  return makeObservable(self, {
    draggedElements: observable,
    drags: observable,
    isDrag: observable,
    mousePos: observable,
    shift: observable,
    toggleToDrag: action,
    setDrag: action,
    clearDrag: action,
    initDragMouse: action,
    moveDragMouse: action,
    clearDraggedElements: action,
  });
};

